import {CheckBox} from '@prtimes-basis/check-box';
import {useController} from 'react-hook-form';
import {useMemo} from 'react';
import styles from './terms-consent-text.module.css';
import {Link} from '@/components/utils/link';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';

export function TermsConsentText() {
  const {control} = useFormField();

  const {
    field: {value, onChange},
    fieldState: {error},
  } = useController({control, name: 'confirmInfo.agreeToTerms'});

  const isError = useMemo(() => error !== undefined, [error]);

  return (
    <FormField.Root name='confirmInfo.agreeToTerms'>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <CheckBox
            required
            label={
              <p className={styles.text}>
                <Link
                  isExternal
                  style={{fontWeight: 'bold'}}
                  to='/main/html/kiyaku'
                >
                  利用規約
                </Link>
                ・
                <Link
                  isExternal
                  style={{fontWeight: 'bold'}}
                  to='https://tayori.com/q/prtimes-contents-guideline'
                >
                  コンテンツ基準
                </Link>
                ・
                <Link
                  isExternal
                  style={{fontWeight: 'bold'}}
                  to='https://prtimes.co.jp/policy/'
                >
                  個人情報のお取り扱いについて
                </Link>
                に同意する
              </p>
            }
            checked={value}
            isError={isError}
            onChecked={(checked) => {
              onChange(checked);
            }}
          />
          <FormField.Error />
        </div>
      </div>
    </FormField.Root>
  );
}
